module.exports = __webpack_public_path__ + "static/img/bg_finance.2e03d11d.jpg";